<template>
    <div>
        <div class="form flex j-between mt--23" style="align-items: end;">
            <div class="form-left ml--30">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="车牌号:" prop="vehicleNumber" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.vehicleNumber" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称:" prop="enterpriseName" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.enterpriseName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="所属车主:" prop="driverName" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.driverName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="车身颜色:" prop="carColor" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.carColor" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="车辆经营区域:" prop="area" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.area" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="车辆型号:" prop="brandModel" class="unset_m" style="margin-right: 15px;">
                        <el-input v-model="searchForm.brandModel" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="核定载客位:" prop="startNum" class="unset_m" style="margin-right: 15px;">
                        <el-form-item prop="startNum" style="margin-right: unset !important;">
                            <el-input class="w--90" v-model="searchForm.startNum" placeholder="请输入最小值"></el-input>
                        </el-form-item>
                        <span class="mr--5 ml--5">-</span>
                        <el-form-item prop="endNum" class="unset_m">
                            <el-input class="w--90" v-model="searchForm.endNum" placeholder="请输入最大值"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <!-- <el-form-item label="车辆运营类型:" prop="operateType" class="unset_m" style="margin-right: 15px;">
                        <el-select :popper-append-to-body="false" v-model="searchForm.operateType" placeholder="请选择">
                            <el-option v-for="(item, index) in options" :key="index" :label="item.name"
                                :value="item.name"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="车辆状态:" prop="status" class="unset_m" style="margin-right: 15px;">
                        <el-select :popper-append-to-body="false" v-model="searchForm.status" placeholder="请选择">
                            <el-option label="在线" value="1"></el-option>
                            <el-option label="异常" value="2"></el-option>
                            <el-option label="离线" value="3"></el-option>
                            <el-option label="故障" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="form-right shrink0 mr--24 mb--23">
                <el-button class="search-button h--40 w--90 fs--14" icon="el-icon-search" type="primary" size="small"
                    @click="search">查询</el-button>
                <el-button @click="reset" icon="el-icon-refresh-right" class="reset-button h--40 w--90 fs--14"
                    size="small">重置</el-button>
            </div>
        </div>

        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-left: 30px;">
            <el-tab-pane v-for="(item,index) in options" :key="index" :label="item.name" :name="item.name"></el-tab-pane>
          
        </el-tabs>

        <div class="table-box ml--30 mt--23 mr--30">
            <el-table :data="tableData" border stripe style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="vehicleNumber" label="车牌号"></el-table-column>
                <el-table-column prop="licensePlateColor" label="车辆颜色"></el-table-column>
                <el-table-column prop="enterpriseName" label="车辆所属公司"></el-table-column>
                <!-- <el-table-column prop="passengerCapacity" label="核定载客位"></el-table-column>
                <el-table-column prop="brandModel" label="车辆型号"></el-table-column>
                <el-table-column prop="vehicleType" label="车辆类型"></el-table-column> -->
                <el-table-column prop="driverName" label="车主"></el-table-column>
                <!-- <el-table-column prop="vehicleColor" label="车身颜色"></el-table-column>
                <el-table-column prop="registrationDate" label="车辆注册日期"></el-table-column>
                <el-table-column prop="operatingArea" label="车辆经营区域"></el-table-column> -->
                <el-table-column prop="operateType" label="车辆运营类型"></el-table-column>
                <el-table-column prop="status" label="车辆状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success">在线</el-tag>
                        <el-tag v-if="scope.row.status == 2" type="danger">异常</el-tag>
                        <el-tag v-if="scope.row.status == 4" type="danger">故障</el-tag>
                        <el-tag v-if="scope.row.status == 3" type="info">离线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" v-permission="31" @click="handle(scope.$index, scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-box relative mt--23 flex j-end">
                <el-pagination :popper-append-to-body="false" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="searchForm.page" background
                    layout="total,sizes,prev, pager, next,jumper" :total="searchForm.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getCarList, getCarType } from './service'
import { search } from 'core-js/fn/symbol';

export default {
    data() {
        return {
            searchForm: {
                vehicleNumber: '', // 车辆号
                enterpriseName: '', // 公司名称
                driverName: '', // 所属车主
                carColor: '', // 车辆颜色
                area: '', // 车辆经营区域
                brandModel: '', // 车辆型号
                startNum: '', // 核定载客位最小值
                endNum: '', // 核定载客位最大值
                operateType: '', // 车辆运营类型
                status: '', // 车辆状态
                total: 0,
                pageCurr: 1,
                pageSize: 10
            },
            options: [],
            tableData: [],
            activeName:'全部'
        };
    },
    created() {
        this.$checkPermission(30)
        getCarType().then(res => {
            let arr = [{name:'全部'}]
            this.options = [...arr, ...res];
        });
        // 判断URL参数并赋值
        const query = this.$route.query;
        if (query && Object.keys(query).length > 0) {
            if (query.id) {
                this.searchForm.operateType = query.id;
                this.activeName = this.searchForm.operateType;
            }
        }
        this.getList();
    },
    methods: {
        handleClick(tab, event) {
            if(tab.name == '全部'){ 
                this.searchForm.operateType = '';
                this.activeName = '全部';
            }else{
                this.searchForm.operateType = tab.name;
                this.activeName = tab.name;
            }
            this.getList();
        },
        reset() {
            this.searchForm = {
                vehicleNumber: '',
                enterpriseName: '',
                driverName: '',
                carColor: '',
                area: '',
                brandModel: '',
                minSeats: '',
                maxSeats: '',
                operateType: '',
                status: '',
                total: 0,
                pageCurr: 1,
                pageSize: 10
            };

            this.getList();
        },
        search() {
            this.searchForm.pageCurr = 1;
            this.getList();
        },
        async getList() {
            try {
                const res = await getCarList({ ...this.searchForm });
                this.tableData = res.records || [];
                this.searchForm.total = res.total || 0;
            } catch (error) {
                // console.error('获取车辆列表失败:', error);
            }
        },
        exportExcell() {
            // TODO: 实现导出功能
        },
        handleSizeChange(e) {
            this.searchForm.pageSize = e;
            this.getList();
        },
        handleCurrentChange(e) {
            this.searchForm.pageCurr = e;
            this.getList();
        },
        handle(index, row) {
            // TODO: 实现详情查看功能
            // console.log('查看详情:', row);
            this.$router.push({ path: '/car-detail', query: { id: row.id } });
        },
    }
}
</script>

<style scoped lang="less">
.search-button {
    height: 40px !important;
}
</style>